<template>
  <vx-card
    class="mt-3 relative z-999"
    id="busca-descontos"
    title="Busca de Descontos"
    collapseAction
    subtitle="Abaixo ficam as descontos encontratos no sistema, você pode fazer uma busca e filtrar as informações que precisa."
  >
    <div class="vx-row">
      <vs-col vs-lg="2" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Código:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase @keyup.enter="buscar()" class="w-full" v-model="filtro.cod" />
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Nome do Cliente:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase @keyup.enter="buscar()" class="w-full" v-model="filtro.nome" />
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>CPF:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input
              v-uppercase
              v-mask="'###.###.###-##'"
              @keyup.enter="buscar()"
              class="w-full"
              v-model="filtro.cpf"
            />
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Tipo De Cobrança:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <forma-pagamento-select v-model="select.formaPagamento"></forma-pagamento-select>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Período de criação:</span>
          </vs-col>

          <vs-col vs-w="12" class="vx-col">
            <daterange-input v-model="ranges.criacao" />
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Período de confirmação:</span>
          </vs-col>
          <vs-col vs-w="6" class="vx-col">
            <datepicker-input v-model="filtro.confirmacaoInicio" placeholder="Início" />
          </vs-col>
          <vs-col vs-w="6" class="vx-col">
            <datepicker-input v-model="filtro.confirmacaoFim" placeholder="Fim" />
          </vs-col>
        </div>
      </vs-col>

      <vs-col v-if="todasAsAssociacoes" vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <span vs-w="12" class="vx-col">
            <span>Associação:</span>
          </span>
          <vs-col vs-w="12" class="vx-col">
            <associacao-select v-model="select.associacao" :clearable="true"></associacao-select>
          </vs-col>
        </div>
      </vs-col>

      <vs-col v-if="todasAsEntidades" vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Entidade:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <entidade-select
              v-model="select.entidade"
              :associacao="select.associacao"
              :clearable="true"
            ></entidade-select>
          </vs-col>
        </div>
      </vs-col>

      <vs-col v-if="todosOsParceiros" vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Parceiro:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <parceiro-select
              v-model="select.parceiro"
              :entidade="select.entidade"
              :clearable="true"
            ></parceiro-select>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-w="12" class="vx-col">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-row justify-between">
            <div class="flex">
              <vs-button
                color="#5abfa3"
                type="relief"
                size="small"
                icon-pack="feather"
                icon="icon-search"
                v-on:click="buscar()"
                class="mr-3"
              >Buscar</vs-button>
              <vs-button
                v-if="possuiFiltros"
                color="#5abfa3"
                type="relief"
                size="small"
                icon-pack="feather"
                icon="icon-search"
                v-on:click="limparFiltros()"
              >Limpar Filtros</vs-button>
            </div>
            <div class="flex">
              <botao-exportar endpoint="contratos" :getParams="getParamsExport" :tipos="['csv']" />
            </div>
          </vs-col>
        </div>
      </vs-col>
    </div>
  </vx-card>
</template>


<script>
import AssociacaoSelect from "@/components/select/AssociacaoSelect.vue";
import ParceiroSelect from "@/components/select/ParceiroSelect.vue";
import EntidadeSelect from "@/components/select/EntidadeSelect.vue";
import FormaPagamentoSelect from "@/components/select/FormaPagamentoSelect.vue";
import DaterangeInput from "@/components/inputs/DaterangeInput.vue";
import DatepickerInput from "@/components/inputs/DatepickerInput.vue";
import BotaoExportar from "@/components/BotaoExportar.vue";
import moment from "moment";

export default {
  name: "busca-contratos",
  components: {
    AssociacaoSelect,
    ParceiroSelect,
    EntidadeSelect,
    FormaPagamentoSelect,
    DaterangeInput,
    DatepickerInput,
    BotaoExportar
  },
  data() {
    return {
      filtro: {},
      ranges: {
        criacao: null
      },
      select: {
        entidade: null,
        associacao: null,
        parceiro: null,
        formaPagamento: null
      }
    };
  },
  created() {
    this.setupFiltros({ ...this.$route.query });
  },
  watch: {
    $route(to) {
      this.setupFiltros({ ...to.query });
    }
  },
  computed: {
    possuiFiltros() {
      return Object.values(this.$route.query).length > 0;
    }
  },
  methods: {
    getParamsExport() {
      return this.$store.getters.fetchParamsContratos({
        status: this.$route.params.status,
        ...this.$route.query
      });
    },
    setupFiltros(query) {
      this.filtro = query;

      if (this.$route.query.entidade) {
        this.select.entidade = this.$store.getters.getEntidades(
          this.$route.query.entidade
        );
      }
      if (this.$route.query.associacao) {
        this.select.associacao = this.$store.getters.getAssociacoes(
          this.$route.query.associacao
        );
      }
      if (this.$route.query.parceiro) {
        this.select.parceiro = this.$store.getters.getParceiros(
          this.$route.query.parceiro
        );
      }

      if (this.$route.query.formaPagamento) {
        this.select.formaPagamento = this.$store.getters.getFormasPagamento(
          this.$route.query.formaPagamento
        );
      }
      if (this.$route.query.criacao) {
        let ranges = ["criacao"];

        ranges.map(range => {
          this.ranges[range] = this.$route.query[range]
            .split("...")
            .map(date => {
              return moment(date).format("DD/MM/YYYY");
            });
        });
      }
    },
    buscar() {
      const selects = ["formaPagamento", "associacao", "entidade", "parceiro"];
      selects.map(select => {
        if (this.select[select]) {
          this.filtro[select] = this.select[select].id;
        } else {
          delete this.filtro[select];
        }
      });

      const ranges = ["criacao"];
      ranges.map(select => {
        if (Array.isArray(this.ranges[select])) {
          this.filtro[select] = `${moment(
            this.ranges[select][0],
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")}...${moment(
            this.ranges[select][1],
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")}`;
        } else {
          delete this.filtro[select];
        }
      });

      delete this.filtro.page;

      this.$router.push({
        name: "contratos",
        params: { status: this.$route.params.status },
        query: { ...this.filtro }
      });
    },
    limparFiltros() {
      this.$router.push({ name: "contratos" });
      this.select = {};
      this.ranges = {};
    }
  }
};
</script>
